import { render, staticRenderFns } from "./ChallengeCloseButton.vue?vue&type=template&id=0793dbbf"
import script from "./ChallengeCloseButton.vue?vue&type=script&lang=js"
export * from "./ChallengeCloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports